import React, { useMemo } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { FaCheckCircle } from 'react-icons/fa'
import { SectionTitle, DetailCard, DetailHeader } from '../styles'

interface AnnotationProgressSectionProps {
  annotated: number
  unannotated: number
}

const AnnotationProgressSection: React.FC<AnnotationProgressSectionProps> = ({
  annotated,
  unannotated,
}) => {
  const { total, percent } = useMemo(() => {
    const totalVal = Math.max(0, (annotated || 0) + (unannotated || 0))
    const pct = totalVal > 0 ? Math.round(((annotated || 0) / totalVal) * 100) : 0
    return { total: totalVal, percent: pct }
  }, [annotated, unannotated])

  return (
    <div>
      <SectionTitle>
        <FaCheckCircle /> Annotation Progress
      </SectionTitle>
      <DetailCard>
        <DetailHeader>
          <h3>{percent}% Complete</h3>
        </DetailHeader>
        <div className="p-3">
          <ProgressBar
            now={percent}
            label={`${percent}%`}
            style={{ height: 20, borderRadius: 12 }}
            variant="success"
          />
          <div className="d-flex justify-content-between mt-3 text-white-50">
            <span>Annotated: {annotated.toLocaleString()}</span>
            <span>Unannotated: {unannotated.toLocaleString()}</span>
            <span>Total: {total.toLocaleString()}</span>
          </div>
        </div>
      </DetailCard>
    </div>
  )
}

export default AnnotationProgressSection
